export default __webpack_public_path__ + "static/media/logo.9591b845.svg";